module.exports = __webpack_public_path__ + "img/greek_flag.608c04d4.png";